<template>
  <v-container
    id="eligibilityGroupDetails"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div v-show="!loading">
      <v-progress-linear
        v-show="savingData"
        indeterminate
        color="green"
      />
      <v-row>
        <v-col
          cols="12"
          md="5"
        >
          <base-resource-select
            label="Location"
            item-text="locationName"
            item-value="id"
            bind-text="locationName"
            bind-value="oeLocationId"
            :bind-item="item"
            :error-messages="formErrors.OELocationId"
            :fetch-method="getLocation"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
        >
          <base-resource-select
            v-if="item.oeLocationId"
            :key="item.oeLocationId"
            label="Job Class"
            item-text="jobClassName"
            item-value="oeJobClassId"
            bind-text="jobClassName"
            bind-value="oeJobClassId"
            :bind-item="item"
            :error-messages="formErrors.OEJobClassId"
            :fetch-method="getJobClass"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
            @click="add"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider
        class="mx-4"
        inset
      />
      <v-alert
        v-if="!detailCount"
        type="info"
      >
        No details defined
      </v-alert>
      <v-card v-show="detailCount">
        <v-list>
          <v-list-item
            v-for="(item, i) in details"
            :key="i"
          >
            <v-list-item-action>
              <v-btn
                color="error"
                class="px-1 ml-1"
                fab
                x-small
                @click="remove(item)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.locationName" />
              <v-list-item-subtitle v-text="item.jobClassName" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'

  export default {
    name: 'EligibilityGroupDetails',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      eligibilityGroup: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      loading: false,
      savingData: false,
      errorMessage: null,
      displayError: false,
      formErrors: {},

      details: null,
      item: {
        oeLocationId: null,
        oeJobClassId: null,
      },

      eligibilityGroupDetailsResource: new TroodyApi('oeEligibilityGroupDetail/'),
      locationResource: new TroodyApi('oeLocation/'),
      jobClassResource: new TroodyApi('oeLocationOEJobClass/'),
    }),

    computed: {
      detailCount () {
        let count = 0
        if (this.details && this.details.length) {
          count = this.details.length
        }
        return count
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadDetails()
      },

      getLocation () {
        return this.locationResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      getJobClass () {
        return this.jobClassResource.query({ openEnrollmentId: this.openEnrollment.id, oeLocationId: this.item.oeLocationId })
      },

      loadDetails () {
        this.loading = true
        this.eligibilityGroupDetailsResource.query({ openEnrollmentId: this.openEnrollment.id, oeEligibilityGroupId: this.eligibilityGroup.id })
          .then(data => {
            this.loading = false
            this.details = data
          })
          .catch((error) => {
            this.loading = false
            this.showError(error, 'Failed to load eligibility group details!')
          })
      },

      add () {
        this.savingData = true

        const payload = {
          openEnrollmentId: this.openEnrollment.id,
          oeEligibilityGroupId: this.eligibilityGroup.id,
          oeLocationId: this.item.oeLocationId,
          oeJobClassId: this.item.oeJobClassId,
        }

        this.eligibilityGroupDetailsResource.save(payload)
          .then((data) => {
            this.savingData = false
            if (!this.details) {
              this.details = []
            }
            this.details.push(data)
            this.$emit('saved', this.details)
            this.item = {
              oeLocationId: null,
              oeJobClassId: null,
            }
            this.formErrors = {}
          })
          .catch((error) => {
            this.savingData = false
            this.formErrors = extractFormErrors(error)
            if (this.formErrors) {
              this.showError(getErrorTitle(error), 'Failed to save!')
            } else {
              this.formErrors = {}
              this.showError(error, 'Failed to save!')
            }
          })
      },

      remove (record) {
        this.savingData = true
        this.eligibilityGroupDetailsResource.delete(record.id)
          .then((data) => {
            this.savingData = false

            // Rebuild the list with everything except the removed item
            this.details = this.details.filter((item) => {
              return item.id !== record.id
            })
            this.formErrors = {}
          })
          .catch((error) => {
            this.savingData = false
            this.showError(error, 'Failed to delete!')
          })
      },

      showError (error, msg) {
        this.loading = false
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
